import Icon from '../components/Icon.vue'

Icon.register({
  tired: {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM281.8 197.7L361.8 149.7C373.4 142.8 385.8 157.4 377.2 167.7L343.6 208 377.2 248.3C385.9 258.7 373.3 273.1 361.8 266.3L281.8 218.3C274.1 213.6 274.1 202.4 281.8 197.7zM118.8 167.7C110.2 157.4 122.6 142.8 134.2 149.7L214.2 197.7C222 202.4 222 213.6 214.2 218.3L134.2 266.3C122.7 273.1 110.2 258.7 118.8 248.3L152.4 208 118.8 167.7zM248 288C299.9 288 363.3 331.8 371.2 394.7 372.9 408.3 363.2 419.3 353.5 415.1 327.6 404 289.1 397.7 248 397.7S168.4 404 142.5 415.1C132.7 419.3 123.1 408.1 124.8 394.7 132.7 331.8 196.1 288 248 288z'
      }
    ]
  }
})
